import React from 'react';
import logoLight from '../../assets/Pathbox-logo-v2-light.png';
import logoDark from '../../assets/Pathbox-logo-v2-dark.png';

interface AuthLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
}

export default function AuthLayout({ leftContent, rightContent }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-base-100">
      {/* Mobile Layout - Single column with logo and link integrated */}
      <div className="lg:hidden">
        <div className="flex flex-col min-h-screen p-6">
          {/* Mobile Logo - Top */}
          <div className="flex justify-center pt-8 pb-6">
            <img 
              src={logoLight} 
              alt="Pathbox Logo" 
              className="h-12 dark:hidden"
            />
            <img 
              src={logoDark} 
              alt="Pathbox Logo" 
              className="h-12 hidden dark:block"
            />
          </div>
          
          {/* Auth form */}
          <div className="flex-1 flex items-center justify-center">
            {rightContent}
          </div>
          
          {/* Mobile Link - Bottom */}
          <div className="flex justify-center pt-6 pb-8">
            <a 
              href="https://pathboxai.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center text-primary hover:text-primary-focus transition-colors duration-200 text-sm dark:text-primary-content dark:hover:text-primary-content/80"
            >
              <span>Visit pathboxai.com</span>
              <svg 
                className="w-4 h-4 ml-1" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Desktop Layout - Side by side */}
      <div className="hidden lg:flex min-h-screen">
        {/* Left Side - Logo and messaging */}
        <div className="flex-1 flex items-center justify-center p-12 bg-gradient-to-br from-primary/10 to-secondary/10">
          {leftContent}
        </div>
        
        {/* Right Side - Auth form */}
        <div className="flex-1 flex items-center justify-center p-12">
          {rightContent}
        </div>
      </div>
    </div>
  );
}
